export default __webpack_public_path__ + "static/media/eggStationary.efd5dc63.gif";